export const NotesMixins = {
  methods: {
    getNoteProps (note) {
      if (!note) return null
      return {
        creator: note.creator.name,
        title: note.title,
        body: note.body,
        date_added: note.date_added,
        tags: note.tags,
        note_type: note.note_type,
        attachments: note.attachments,
        is_locked: note.is_locked,
        reference: note.reference,
        subReferences: note.subReferences
      }
    }
  }
}
